import React, { useCallback } from 'react'
import * as Icons from 'assets/icons/groove/v2'
import Sidebar from 'components/App/DesktopView/Layout/Sidebar'
import Item from '../Item'
import styles from '../styles.less'

export default function Group({
  groupId,
  name,
  open,
  onClick,
  icon,
  folderIds,
}) {
  const handleClick = useCallback(
    () => {
      if (onClick) onClick(groupId)
    },
    [onClick, groupId]
  )
  const GroupIcon = Icons[icon]
  const title = (
    <div onClick={handleClick}>
      <span className={styles.icon}>
        <GroupIcon />
      </span>
      <span>{name}</span>
    </div>
  )
  return (
    <Sidebar.Accordion
      key={groupId}
      initiallyActive={open}
      title={title}
      padded={3}
    >
      {open &&
        folderIds.map(listId => (
          <Item key={listId} itemId={listId} padded={4} />
        ))}
    </Sidebar.Accordion>
  )
}
